const nextRoutes = require('next-routes');

const routes = nextRoutes();

routes.add({
  name: 'home',
  page: '',
  pattern: '/:certificateId'
});

module.exports = routes;
